import * as React from 'react';
import { Field, FieldRenderProps } from 'react-final-form';
import { VFFieldProps } from '../types';
import { ColSpanEnum, FormItem } from './FormItem';
import classNames from 'classnames';
import { MonthInput } from '../../datetime/MonthInput';
import { DATA_FORM_INPUT } from '../../common/data';

export type MonthProps = Omit<
  VFFieldProps<React.ComponentProps<typeof MonthInput>>,
  'value'
> & { fullWidth?: boolean };
export const Month = React.forwardRef<HTMLInputElement, MonthProps>(
  (
    {
      name,
      inlineValidation,
      validate,
      className,
      inputClassName,
      contentClassName,
      label,
      required,
      disabled,
      readOnly,
      fullWidth = false,
      validateWarning,
      ...other
    },
    ref
  ) => {
    return (
      <FormItem
        name={name}
        inlineValidation={inlineValidation}
        className={className}
        label={label}
        required={required}
        disabled={disabled}
        readOnly={readOnly}
        colSpan={fullWidth ? undefined : ColSpanEnum.Three}
        validateWarning={validateWarning}
        contentClassName={contentClassName}
      >
        <Field name={name}>
          {({
            input: { value, onChange, onBlur },
            meta,
          }: FieldRenderProps<any>) => {
            return (
              <MonthInput
                {...DATA_FORM_INPUT(name)}
                fullWidth={fullWidth}
                {...other}
                disabled={disabled || meta.submitting}
                readOnly={readOnly}
                className={classNames(inputClassName)}
                onChange={(newValue) => {
                  onChange({ target: { name, value: newValue } });
                }}
                onBlur={(newValue) => {
                  onBlur({
                    target: { name, value: newValue },
                  } as any as React.FocusEvent<HTMLElement>);
                }}
                value={value}
                // @ts-ignore
                ref={ref}
              />
            );
          }}
        </Field>
      </FormItem>
    );
  }
);
